module.exports = __webpack_public_path__ + "static/media/iconStatistics.5dd7cf55.svg";